// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FGDt","largestCol":"styles_largestCol__3tWvD","smallestCol":"styles_smallestCol__ds6Hx"};